import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import TeamProfileWidget from "./TeamProfileWidget" ;
import D3EDisposable from "../rocket/D3EDisposable" ;
import Popup from "./Popup" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import Query from "../classes/Query" ;
import AddUserView from "./AddUserView" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import SearchComponent from "./SearchComponent" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import CheckboxWithText from "./CheckboxWithText" ;
import ScrollView2 from "./ScrollView2" ;
import Company from "../models/Company" ;
import TwilioClient from "../classes/TwilioClient" ;
import TextView from "./TextView" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import Divider from "./Divider" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _UserButtonOnPressed = ( d3eState : TeamViewRefs ) => void ;

type _CheckboxWithTextOnChanged = ( text : boolean,d3eState : TeamViewRefs ) => void ;


  export  interface  TeamViewProps extends  BaseUIProps {   key?: string ;
   manager: User ;
   company: Company ;
   client: TwilioClient ;
   data: CallData ;
 }
/// To store state data for TeamView 
   class  TeamViewRefs {   columnScrollController: ui.ScrollController = new ui.ScrollController() ;
  public userButton: UserButtonState = new UserButtonState() ;
 }

   interface  UserButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: TeamViewRefs ;
   _onAddUserHandler?: _UserButtonOnPressed ;
 }

   class  UserButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _UserButtonWithState extends  ObservableComponent<UserButtonWithStateProps> {   userButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : UserButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get userButton (  ) : UserButtonState {
 return this.props.d3eState.userButton ; 
 }
  public get d3eState (  ) : TeamViewRefs {
 return this.props.d3eState ; 
 }
  public get _onAddUserHandler (  ) : _UserButtonOnPressed {
 return this.props._onAddUserHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('userButton',null,this.userButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'userButton', 'userButton.hover' ],this.rebuild);
 }
  public userButtonOnEnter ( event ) : void {
 return this.userButton.setHover(true) ; 
 }
  public userButtonOnExit ( event ) : void {
 return this.userButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.userButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ width:120, child:Button({ padding:cStyle.tButtonPrimaryPaddingOn, decoration:cStyle.tButtonPrimaryDecorationOn, disable:this.userButton.disable, onPressed:(  ) => {
 this._onAddUserHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Add User' }), onEnter:( event ) => {
 this.userButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.userButtonOnExit(event);
 }
 }), className:'Primary xffd hc' }) ; 
 }
 }
function UserButtonWithState ( props : UserButtonWithStateProps ) {
 return React.createElement(_UserButtonWithState,props) ; 
 }


   class  _TeamViewState extends  ObservableComponent<TeamViewProps> {   static defaultProps = { manager:null, company:null, client:null, data:null } ;
   d3eState: TeamViewRefs = new TeamViewRefs() ;
   subordinates: Array<User> = ListWrapper.widget(this,'subordinates') ;
   filterList: Array<User> = ListWrapper.widget(this,'filterList') ;
   searchText: string = '' ;
   disabledUsers: boolean = false ;
   addUserPopupPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public managerDisposable: D3EDisposable ;
 public constructor ( props : TeamViewProps ) {
 super(props);

this.initState();
 }
  public get manager (  ) : User {
 return this.props.manager ; 
 }
  public get company (  ) : Company {
 return this.props.company ; 
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public initState (  ) {
 super.initState();

this.managerDisposable=MessageDispatch.get().syncObject(this.props.manager,UsageConstants.SUBSCRIPTION_ONUSERCHANGE_TEAMVIEW_MANAGER_SYNCHRONISE);

this.runFetchDataQueryForManager();

this.managerDisposable=MessageDispatch.get().syncObject(this.props.manager,UsageConstants.QUERY_GETUSERBYID_TEAMVIEW_MANAGER_FETCHDATA);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('manager',this.props.manager);

this.on([ 'manager', 'manager.subordinates' ],this.computeSubordinates);

this.computeSubordinates();

this.on([ 'searchText', 'subordinates', 'subordinates.firstName', 'subordinates.lastName' ],this.computeFilterList);

this.computeFilterList();

this.updateSyncProperty('company',this.props.company);

this.updateSyncProperty('data',this.props.data);

this.on([ 'disabledUsers', 'filterList', 'filterList.status' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : TeamViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.manager !== this.props.manager ) {
 this.updateObservable('manager',prevProps.manager,this.props.manager);

this.runFetchDataQueryForManager();

this.fire('manager',this);
 }

if ( prevProps.company !== this.props.company ) {
 this.updateObservable('company',prevProps.company,this.props.company);

this.fire('company',this);
 }

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }
 }
  public runFetchDataQueryForManager  =  (  ) : void  =>  {
 if ( this.manager == null ) {
 return ; 
 }

Query.get().getUserById(UsageConstants.QUERY_GETUSERBYID_TEAMVIEW_MANAGER_FETCHDATA,this.manager.id);
 }
  public setSubordinates ( val : Array<User> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.subordinates,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('subordinates',this.subordinates,val);

this.subordinates.clear();

this.subordinates.addAll(val);

this.fire('subordinates',this);
 }
  public addToSubordinates ( val : User,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.subordinates.contains(val) ) this.subordinates.add(val);
 }
 else {
 this.subordinates.remove(this.subordinates.elementAt(index));

this.subordinates.add(val);
 }

this.fire('subordinates',this,val,true);

this.updateObservable('subordinates',null,val);
 }
  public removeFromSubordinates ( val : User ) : void {
 this.subordinates.remove(val);

this.fire('subordinates',this,val,false);

this.removeObservable('subordinates',val);
 }
  public computeSubordinates  =  (  ) : void  =>  {
 try {
 this.setSubordinates(Array.from(this.manager.subordinates));
 }
 catch ( exception ) {
 console.log(' exception in computeSubordinates : ' + exception.toString());

this.setSubordinates([  ]);
 }
 }
  public setFilterList ( val : Array<User> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.filterList,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('filterList',this.filterList,val);

this.filterList.clear();

this.filterList.addAll(val);

this.fire('filterList',this);
 }
  public addToFilterList ( val : User,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.filterList.contains(val) ) this.filterList.add(val);
 }
 else {
 this.filterList.remove(this.filterList.elementAt(index));

this.filterList.add(val);
 }

this.fire('filterList',this,val,true);

this.updateObservable('filterList',null,val);
 }
  public removeFromFilterList ( val : User ) : void {
 this.filterList.remove(val);

this.fire('filterList',this,val,false);

this.removeObservable('filterList',val);
 }
  public computeFilterList  =  (  ) : void  =>  {
 try {
 this.setFilterList(Array.from(this.subordinates.where(( u ) => this.searchText === null || this.searchText.isEmpty || u.firstName.toLowerCase().contains(this.searchText.toLowerCase()) || u.lastName.toLowerCase().contains(this.searchText.toLowerCase())).toList()));
 }
 catch ( exception ) {
 console.log(' exception in computeFilterList : ' + exception.toString());

this.setFilterList([  ]);
 }
 }
  public setSearchText ( val : string ) : void {
 let isValChanged :boolean=this.searchText !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchText=val;

this.fire('searchText',this);
 }
  public setDisabledUsers ( val : boolean ) : void {
 let isValChanged :boolean=this.disabledUsers !== val;

if ( !isValChanged ) {
 return ; 
 }

this.disabledUsers=val;

this.fire('disabledUsers',this);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ ui.Container({ width:300, child:SearchComponent({ placeholder:'Search User', onChanged:( value ) => {
 this.onSearchHandler(value,this.d3eState);
 }
 }), key:'0', className:'x4dde hc' }), ui.Row({ children:[ CheckboxWithText({ title:'Include Disabled Users', value:this.disabledUsers, activeColor:cStyle.c1, onChanged:( text ) => {
 this.checkboxWithTextonChanged(text,this.d3eState);
 }
, key:'0' }), ui.Container({ className:'xe24 hc', key:'1' }), UserButtonWithState({ d3eState:this.d3eState, _onAddUserHandler:this.onAddUserHandler, key:'2' }) ], key:'1' }) ], className:'xee2 hc h', key:'0' }), ui.Container({ height:1, margin:ui.EdgeInsets.symmetric({horizontal:0.0,vertical:20.0,transitions:new Map()}), child:Divider({  }), key:'1', className:'xe8f hc vc h' }), ScrollView2({child:ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Wrap({ spacing:5, runSpacing:10, children:[ (this.filterList.where(( u ) => this.disabledUsers || u.status).toList()).expand(( forItem ) => [ ui.Container({ height:300, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), width:250, child:TeamProfileWidget({ user:forItem, onClick:(  ) => {
 this.teamProfileWidgetHandler(forItem,this.d3eState);
 }
 }), key:forItem?.ident, className:'x9b4 hc vc' }) ]) ], className:'hc', key:'0' }) ], key:'2' }),scrollDirection:ui.Axis.vertical,className:'x36f hc vc v',controller:this.d3eState.columnScrollController}) ], className:'BaseViewStyle x0a66 hc vc h v', key:'0' }) ], className:ui.join('TeamView xa78 hc vc h v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onSearchHandler  =  ( value : string,d3eState : TeamViewRefs ) : void  =>  {
 this.setSearchText(value);
 }
  public onAddUserHandler  =  ( d3eState : TeamViewRefs ) : void  =>  {
 this.showAddUserPopup();
 }
  public teamProfileWidgetHandler  =  ( forItem : User,d3eState : TeamViewRefs ) : void  =>  {
 this.navigator.pushTeamOverviewPage({ user:forItem, client:this.client, data:this.data, target:'main', replace:false });
 }
  public dispose (  ) : void {
 this.managerDisposable?.dispose();

this.addUserPopupPopup?.dispose();

super.dispose();
 }
  public showAddUserPopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.addUserPopupPopup ?. dispose();

this.addUserPopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:ui.Container({ width:550, child:AddUserView({ user:new User({ company:this.company, reportingManager:this.manager }), isAdmin:false }), className:'xb24 hc vc' })});

this.addUserPopupPopup.showPopup(this.context);
 }
  public hideAddUserPopup (  ) : void {
 this.addUserPopupPopup ?. dispose();
 }
  public checkboxWithTextonChanged  =  ( val : boolean,d3eState : TeamViewRefs ) : void  =>  {
 this.setDisabledUsers(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get userButton (  ) {
 return this.d3eState.userButton ; 
 }
 }
export default function TeamView ( props : TeamViewProps ) {
 return React.createElement(_TeamViewState,{ ..._TeamViewState.defaultProps, ...props }) ; 
 }
